import * as React from 'react';
import type { OnlineStudyPlannerSectionTranslations } from '~/Pages/OnlineStudyPage/ViewModel/StudyPlanner/TranslationsModels/OnlineStudyPlannerSectionTranslations.csharp';

interface PlannerContextTranslationsProviderProps {
    translations: OnlineStudyPlannerSectionTranslations;
}

const Context = React.createContext<OnlineStudyPlannerSectionTranslations | null>(null);

export const PlannerContextTranslationsProvider: React.FC<
    React.PropsWithChildren<PlannerContextTranslationsProviderProps>
> = props => {
    const { children, translations } = props;

    return <Context.Provider value={translations}>{children}</Context.Provider>;
};

export const usePlannerTranslations = () => {
    const context = React.useContext(Context);

    if (!context) {
        throw new Error('Planer Translations Context has not been initialized');
    }

    return context;
};
